<icz-object-association-alert [heading]="heading" [associatedObjectClass]="ObjectClass.CASE_FILE">
  <ng-container afterHeading>
    @if (!isCaseFileInfoUnavailable && caseFileInfo) {
      <a class="p-4" iczLinkWithoutHref (click)="openCaseFileDetail(caseFileInfo!)">
        <span>{{caseFileInfo!.name}}</span>
      </a>
      {{ 'do součásti' | translate }}
      <a class="p-4" iczLinkWithoutHref (click)="openCaseFilePartDetail(caseFileInfo!)">
        <span>{{caseFileInfo!.partName}}</span>
      </a>
    }
  </ng-container>
</icz-object-association-alert>
